export default "__VITE_ASSET__DH1N5UDl__"